import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';


const MyDropzone = ({ formik }: any) => {
  const [files, setFiles] = useState<any>([]);
  const [rejected, setRejected] = useState<any>([])

  const onDrop = useCallback((acceptedFiles: any, rejectedFiles: any) => {
    if (acceptedFiles?.length) {
      setFiles((prev: any) => [...prev, ...acceptedFiles.map((item: any) =>
        Object.assign(item, { prev: URL.createObjectURL(item) })
      ),
      ]);
    }
    if (rejectedFiles?.length) {
      setRejected((prev: any) => [...prev, ...rejectedFiles])
      alert(rejectedFiles[0].errors[0].message)
    }
  }, []);

  console.log('rejected', rejected)

  useEffect(() => {
    formik.setFieldValue('image', files)
  }, [files?.length])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/svg': [],
      '.doc': [],
      '.docx': []
    },
    maxSize: 1024 * 2000,
  });

  const removeFile = (name: any) => {
    setFiles((files: any) => files.filter((file: any) => file?.name !== name))
  }

  return (
    <>
      <ul className="d-flex list-inline p-0 mb-0 product-drag-drop">

        {files.map((item: any) => {
          return (
            <>
              <li className="list-inline-item position-relative" key={item?.name}>
                <img src={item?.prev}
                  alt="anything"
                  width={100}
                  height={100}
                  onLoad={() => { URL.revokeObjectURL(files.prev) }}
                  className="img-fluid rounded-md"
                />
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => removeFile(item?.name)}
                >
                </button>
              </li>


            </>
          )
        })}

        <li className="list-inline-item position-relative">
          <div className="drag-drop d-flex h-100">
            <div {...getRootProps()} className={'dropzone d-flex align-items-center'} >
              <input className="input-zone" {...getInputProps()} />
              <div className="text-center">
                {isDragActive ? (
                  <p className="dropzone-content mb-0">Release to drop the files here</p>
                ) : (
                  <p className="dropzone-content mb-0">Drag’ n’ drop some files here, or click to select files</p>
                )}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </>
  );
};
export default MyDropzone;